import React from "react";
import $ from "jquery";
import "./L1C1.css";
import Card from "@material-ui/core/Card";
import Slider from "@material-ui/core/Slider";
import cb0 from "static/images/l1c1/cb-0.png";
import cb1 from "static/images/l1c1/cb-1.png";
import cb2 from "static/images/l1c1/cb-2.png";
import cb3 from "static/images/l1c1/cb-3.png";
import cb4 from "static/images/l1c1/cb-4.png";
import cb5 from "static/images/l1c1/cb-5.png";
import cb6 from "static/images/l1c1/cb-6.png";
import cb7 from "static/images/l1c1/cb-7.png";
import cb8 from "static/images/l1c1/cb-8.png";
import cb9 from "static/images/l1c1/cb-9.png";
import tb0 from "static/images/l1c1/tb-0.png";
import tb1 from "static/images/l1c1/tb-1.png";
import tb2 from "static/images/l1c1/tb-2.png";
import tb3 from "static/images/l1c1/tb-3.png";
import tb4 from "static/images/l1c1/tb-4.png";
import tb5 from "static/images/l1c1/tb-5.png";
import tb6 from "static/images/l1c1/tb-6.png";
import tb7 from "static/images/l1c1/tb-7.png";
import tb8 from "static/images/l1c1/tb-8.png";
import tb9 from "static/images/l1c1/tb-9.png";
const isNumber = require("is-number");

var local;

const cbs = [cb0, cb1, cb2, cb3, cb4, cb5, cb6, cb7, cb8, cb9];
const tbs = [tb0, tb1, tb2, tb3, tb4, tb5, tb6, tb7, tb8, tb9];

var langDict = [
  "中文",
  "English",
  "日本語",
  "Deutsch",
  "русский язык",
  "한국어",
];
var langAbbr = ["zh", "en", "ja", "de", "ru", "kr"];

// 部分组件
const sliderStyle = {
  margin: "20px",
  width: "100%",
};

// safe guard
function getNumber(number) {
  if (isNumber(number)) return parseInt(number);
  return 0;
}

function getImages(images, idx) {
  const img = images[getNumber(idx)];
  return img;
}

class L1c1 extends React.Component {
  colors = [
    "#1abc9c",
    "#2ecc71",
    "#3498db",
    "#9b59b6",
    "#34495e",
    "#f1c40f",
    "#e67e22",
    "#e74c3c",
    "#ecf0f1",
    "#95a5a6",
  ];
  races = ["人类", "精灵", "兽人", "地精", "亡灵"];
  scale = ["小型城堡", "中型城堡", "大型城堡"];
  eco = [6, 8, 3, 7, 4];
  fire = [6, 3, 8, 4, 7];
  cdata = [];

  constructor(props) {
    super(props);

    local = require("./L1C1l" + langAbbr[getNumber(props.lang)] + ".js");

    this.state = {
      middleHeight: window.innerHeight,
      cbType: 0,
      cbColor: 0,
      hbWhere: 0,
      hbcolor: 0,
      hbType: 0,
      race: 0,
      size: 0,
      special: 0,
    };

    if (sessionStorage.getItem("mycastle") === null) {
      sessionStorage.setItem("mycastle", [0, 0, 0, 0, 0, 0, 0, 0]);
    }
  }

  get transformStyle() {
    const { size } = this.state;
    const factor = 0.05;
    const scaleup = size * factor + 1;
    return {
      transform: `scale(${scaleup}, ${scaleup})`,
      "transform-origin": "bottom",
    };
  }

  componentWillMount() {
    if (sessionStorage.getItem("mycastle") !== null) {
      this.cdata = sessionStorage.getItem("mycastle").split(",");

      this.setState({
        middleHeight: window.innerHeight,
        cbType: getNumber(this.cdata[1]),
        cbColor: getNumber(this.cdata[2]),
        hbWhere: getNumber(this.cdata[5]),
        hbcolor: getNumber(this.cdata[4]),
        hbType: getNumber(this.cdata[3]),
        race: getNumber(this.cdata[6]),
        size: getNumber(this.cdata[0]),
        special: getNumber(this.cdata[7]),
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    local = require("./L1C1l" + langAbbr[getNumber(nextProps.lang)] + ".js");
  }

  handleResize = (e) => {
    this.setState({
      middleHeight: e.target.innerHeight < 400 ? 400 : e.target.innerHeight,
    });
  };

  componentDidMount = () => {
    switch (this.state.hbWhere % 4) {
      case 1:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -20%)");
        break;
      case 2:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -80%)");
        break;
      case 3:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -80%)");
        break;
      default:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -20%)");
        break;
    }
    //this.changepic();
  };

  componentWillUnmount = () => {};

  changepic = () => {
    this.setState({
      // cbType: getNumber($("#cbtype")[0].innerText),
      cbColor: getNumber($("#cbcolor")[0].innerText),
      hbWhere: getNumber($("#hblocate")[0].innerText),
      hbcolor: getNumber($("#hbcolor")[0].innerText),
      hbType: getNumber($("#hbType")[0].innerText),
      race: getNumber($("#race")[0].innerText),
      // size: getNumber($("#size")[0].innerText),
      special: getNumber($("#special")[0].innerText),
    });

    // 徽标位置
    switch ($("#hblocate")[0].innerText % 4) {
      case 1:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -20%)");
        break;
      case 2:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -80%)");
        break;
      case 3:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -80%)");
        break;
      default:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -20%)");
        break;
    }

    var castledata = [
      // getNumber($("#size")[0].innerText),
      // getNumber($("#cbtype")[0].innerText),
      getNumber($("#cbcolor")[0].innerText),
      getNumber($("#hbType")[0].innerText),
      getNumber($("#hbcolor")[0].innerText),
      getNumber($("#hblocate")[0].innerText),
      getNumber($("#race")[0].innerText),
      getNumber($("#special")[0].innerText),
    ];
    sessionStorage.setItem("mycastle", castledata);
  };

  render() {
    return (
      <div className="configContainer">
        <div className="headerNote">
          <h3>{local.local.instruction}</h3>
        </div>
        <div className="row">
          <div className="clash-card barbarian">
            <div className="clash-card__image clash-card__image--barbarian">
              <img
                src={cbs[getNumber(this.state.race)]}
                alt="eye"
                style={{
                  filter: "hue-rotate(" + this.state.cbColor * 30 + "deg)",
                }}
              />

              <div
                id="hbbox"
                className="hbbox"
                style={{ position: "absolute", width: "5vw", padding: "4%" }}
              >
                <img
                  src={tbs[getNumber(this.state.hbType)]}
                  alt="tb"
                  style={{
                    position: "relative",
                    width: "100%",
                    filter:
                      "brightness(50%) sepia(100) saturate(25) hue-rotate(" +
                      this.state.hbcolor * 30 +
                      "deg)",
                  }}
                  id="hb"
                />
              </div>
            </div>

            <div className="clash-card__level clash-card__level--barbarian">
              Level 1
            </div>
            <div className="clash-card__unit-description">
              {local.local.serialNumber}
            </div>
            <div className="clash-card__unit-name">
              {/* {this.state.size} */}
              {/* {this.state.cbType} */}
              {this.state.cbColor}
              {this.state.hbType}
              {this.state.hbcolor}
              {this.state.hbWhere}
              {this.state.race}
              {this.state.special}
            </div>
            <div className="clash-card__unit-description">
              {local.local.scale[this.state.size % 3]}
              <br />
              {local.local.specialid}：{this.state.special}
            </div>

            <div className="clash-card__unit-stats clash-card__unit-stats--barbarian clearfix">
              <div style={{ padding: "2% 3%" }}>
                <div className="chinese">
                  {local.local.races[this.state.race % 5]}
                </div>
                <div className="stat-value">{local.local.race}</div>
              </div>

              {/* <div className="one-third">
                <div className="stat">{this.eco[this.state.race % 5]}</div>
                <div className="stat-value">{local.local.economic}</div>
              </div>

              <div className="one-third no-border">
                <div className="stat">{this.fire[this.state.race % 5]}</div>
                <div className="stat-value">{local.local.military}</div>
              </div> */}
            </div>
          </div>
          <Card className="config-card">
            {/* <span>
              {local.local.cards[0]}：{this.state.size}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[0]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="size"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[1]}：{this.state.cbType}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[1]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="cbtype"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider> */}
            <span>
              {local.local.cards[2]}：{this.state.cbColor}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[2]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="cbcolor"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[3]}：{this.state.hbType}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[3]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="hbType"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[4]}：{this.state.hbcolor}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[4]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="hbcolor"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[5]}：{this.state.hbWhere}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[5]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              style={{ sliderStyle }}
              id="hblocate"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[6]}：{this.state.race}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[6]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={4}
              id="race"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
            <span>
              {local.local.cards[7]}：{this.state.special}
            </span>
            <br />
            <Slider
              className="slider-item"
              defaultValue={this.cdata.length ? parseInt(this.cdata[7]) : 0}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={9}
              id="special"
              onChange={this.changepic}
              onClick={this.changepic}
            ></Slider>
          </Card>
        </div>
      </div>
    );
  }
}

export default L1c1;
